export default __webpack_public_path__ + "static/media/sabah88_Icon.37c5fbfa.png";